import { RegionsAndCommunesBody } from '../../types/RegionsAndCommunesTypes';
import { PARAMETERS } from '../endpoints';
import request from '../request';

/**
 * Obtiene el listado de regiones y comunas
 */
export const getRegionsAndCommunesRequest = () =>
  request<RegionsAndCommunesBody>(PARAMETERS.REGION_AND_COMMUNES);
